<template>
  <div class="test_page">
    <component
      :is="type"
      :is-questions-one="type === 'one'"
      :test="test"
      :has-anticheating="hasAnticheating"
      @end="$emit('end')"
      @timeout="$emit('timeout')"
      @screenshots_error="$emit('screenshots-error')"
    />
  </div>
</template>

<script>
/*
  Выбираем что рендерим, пошагово или сразу все
*/
import { STORE_PREFIX } from '../../constants.js';
import { mapGetters } from 'vuex';
import axios from 'axios';
import one from './questions_one';
import all from './questions_all';

export default {
  name: 'Test',

  components: { all, one },

  props: {
    hasAnticheating: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      keyUpListener: null
    };
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'test', { test: 'item', token: 'token', questionId: 'questions/current_opened_id' }),

    type() {
      let type;

      switch (this.test.page_view) {
        case 'separate_per_question': {
          type = 'one';
          break;
        }
        default: {
          type = 'all';
        }
      }

      return type;
    }
  },

  created() {
    if (this.hasAnticheating) {
      document.addEventListener('keyup', e => {
        const keyCode = e.keyCode ? e.keyCode : e.which;
        if (keyCode == 44) {
          this.stopPrntScr();
        }
      });

      document.addEventListener('keydown', e => {
        if (e.metaKey) {
          this.stopPrntScr();
        }
      });
    }
  },

  methods: {
    stopPrntScr() {
      let inpFld = document.createElement('input');
      inpFld.setAttribute('value', '.');
      inpFld.setAttribute('width', '0');
      inpFld.style.height = '0px';
      inpFld.style.width = '0px';
      inpFld.style.border = '0px';
      document.body.appendChild(inpFld);
      inpFld.select();
      document.execCommand('copy');
      inpFld.remove(inpFld);

      if (this.hasAnticheating) {
        let params = { event: 'printscreen-pressed' };

        if (this.type === 'one') {
          params.question_id = this.questionId;
        }

        axios.put(`/1.0/interviews/${this.token}/tests/candidate-event`, params).then(() => {
          this.$noty.error(this.$tr('interviewTest.preventPrintScreen'));
        });
      }

      try {
        window.clipboardData.setData('text', 'Access Restricted');
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
